import { compose, withProps } from 'recompose'
import { createWithLazyEntities } from '@infotech/lib-api-middleware'

import {
  ESUZ_ISSUES_SCHEMA_NAME,
  esuzIssuesApiActions,
  esuzIssuesSelector,
  esuzIssuesEntitiesSelector,
} from 'api/esuzIssues'

const withEsuzIssues = createWithLazyEntities({
  entitiesSelector: esuzIssuesEntitiesSelector,
  dataSelector    : esuzIssuesSelector,
  schemaName      : ESUZ_ISSUES_SCHEMA_NAME,
  fetchApiAction  : esuzIssuesApiActions.fetch,
  dataPropName    : `esuzIssues`,
})

export const esuzIssueTransport = compose(
  withProps(({ esuzIssueId }) => ({
    query: {
      idEq : esuzIssueId,
      limit: 20,
    },
  })),
  withEsuzIssues,
)
